<orbit-dialog-header transparent centerTitle>
  <div class="left-addon" left-addon>
    <div class="counter">
      <span class="current-index">{{ selectedMessageIndex() + 1 }}</span>
      <span class="total-index">&nbsp;/ {{ assetsMessages().length }}</span>
    </div>
  </div>
  <div class="right-addon" right-addon>
    <button
      type="button"
      class="button-reset close-icon"
      tabindex="0"
      (click)="closeDialog()"
      (keydown)="onCloseKeyDown($event)">
      <orbit-fa-icon [iconName]="closeIcon" />
    </button>
  </div>
</orbit-dialog-header>

<div class="dialog-content">
  <div class="preview">
    <button
      type="button"
      class="button-reset arrow-left"
      (click)="onLeftClick()"
      (keydown)="onLeftKeyDown($event)"
      tabindex="0">
      <orbit-fa-icon [iconName]="leftIcon" />
    </button>
    @switch (selectedMessage()?.kind) {
      @case (messageKindEnum.Image) {
        <img
          [src]="selectedMessage()?.asset?.downloadUrl"
          [attr.alt]="selectedMessage()?.text || 'message attachment'"
          class="asset" />
      }

      @case (messageKindEnum.Audio) {
        <audio controls [src]="selectedMessage()?.asset?.downloadUrl" class="asset"></audio>
      }

      @case (messageKindEnum.Video) {
        <video controls autoplay playsinline preload="none" class="asset">
          <source [src]="selectedMessage()?.asset?.downloadUrl" type="video/mp4" />
        </video>
      }
    }
    <button
      type="button"
      class="button-reset arrow-right"
      (click)="onRightClick()"
      (keydown)="onRightKeyDown($event)"
      tabindex="0">
      <orbit-fa-icon [iconName]="rightIcon" />
    </button>
  </div>
  <div class="thumbnails">
    @for (message of assetsMessages(); track message.id; let i = $index) {
      @if (message.asset) {
        <button
          type="button"
          class="button-reset thumbnail"
          (click)="selectMessage(message)"
          (keydown)="onSelectMessageKeyDown($event, message)"
          [ngClass]="{ active: selectedMessage()?.id === message.id }"
          [tabindex]="i + 1">
          @switch (message.kind) {
            @case (messageKindEnum.Image) {
              <img
                [src]="message.asset.thumbnailUrl || message.asset.downloadUrl"
                [attr.alt]="message.text || 'thumbnail'"
                class="message-image" />
            }

            @case (messageKindEnum.Audio) {
              <orbit-fa-icon class="audio-icon" [iconName]="audioIcon" />
            }

            @case (messageKindEnum.Video) {
              <orbit-fa-icon class="video-icon" [iconName]="videoIcon" />
            }
          }
        </button>
      }
    }
  </div>
</div>
